import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import apiClient from "../../api-services/ApiClient";
import queryString from "query-string";
import Preloader from "../../app-components/preloader/Preloader";
import { errorAlert } from "../../app-util/SweetAlert";
import { storeToken, storeUser } from "../../api-services/process";
import { ELITELINKS, SITELINKS } from "../../app-routes/links";
import { App } from "@capacitor/app";

const GoogleCallback = () => {
  const navigate = useNavigate();

  const GoogleLogin = async (access_token: any) => {
    try {
      const data = { access_token };
      const res = await apiClient.post("/login-with-google", data);
      const user = res.data?.data?.user;

      storeToken(res.data?.data?.token);
      storeUser(user);

      if (!user?.username || !user?.DOB) {
        navigate(SITELINKS.REGISTER_STEP_TWO);
      } else {
        navigate(ELITELINKS.ELITE);
      }
    } catch (error: any) {
      console.log(error);
      errorAlert();
      navigate(SITELINKS.LOGIN);
    }
  };

  useEffect(() => {
    let listener: any;

    const setupListener = async () => {
      listener = await App.addListener("appUrlOpen", (event: any) => {
        if (event.url.includes("auth")) {
          const url = new URL(event.url);
          const hash = url.hash;
          const { access_token } = queryString.parse(hash);

          if (access_token) {
            GoogleLogin(access_token);
          } else {
            errorAlert();
            navigate(SITELINKS.LOGIN);
          }
        }
      });
    };

    setupListener();

    // ✅ WEB: fallback (browser redirect)
    const { access_token } = queryString.parse(window.location.hash);

    if (access_token) GoogleLogin(access_token);
    // else {
    //   errorAlert();
    //   navigate("/login");
    // }

    return () => {
      if (listener) {
        listener.remove();
      }
    };

    // eslint-disable-next-line
  }, [navigate]);

  return <Preloader loading={true} />;
};

export default GoogleCallback;
